import { render, staticRenderFns } from "./DecreaseItemCart.vue?vue&type=template&id=5cd168de"
import script from "./DecreaseItemCart.vue?vue&type=script&lang=ts"
export * from "./DecreaseItemCart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports